import { render, staticRenderFns } from "./UpList.vue?vue&type=template&id=5df74304&scoped=true&"
import script from "./UpList.vue?vue&type=script&lang=js&"
export * from "./UpList.vue?vue&type=script&lang=js&"
import style0 from "./UpList.vue?vue&type=style&index=0&id=5df74304&lang=scss&scoped=true&"
import style1 from "./UpList.vue?vue&type=style&index=1&id=5df74304&lang=scss&scoped=true&"
import style2 from "./UpList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df74304",
  null
  
)

component.options.__file = "UpList.vue"
export default component.exports